import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest';
import { TransactionsSheetItem } from '../../Models/Transactions';
import { InterActive } from '../../utilities/ViewModelStructure';
import * as XLSX from 'xlsx';
import { Notify } from '../../Handlers/Notifications';

export class TransactionsSheetVM extends InterActive{
    private data:TransactionsSheetItem[] = [];
    public get Data():TransactionsSheetItem[]{ return this.data  }
    public set Data(value:TransactionsSheetItem[]){ this.data = value ; this.update()  }

    private search:string = '';
    public get Search():string{ return this.search  }
    public set Search(value:string){ this.search = value ; this.update()  } 

    private total:string = '0';
    public get Total():string{ return this.total  }
    public set Total(value:string){ this.total = value ; this.update()  }

    private from:string = '';
    public get From():string{ return this.from  }
    public set From(value:string){ this.from = value ; this.update()  }

    private to:string = '';
    public get To():string{ return this.to  }
    public set To(value:string){ this.to = value ; this.update()  } 

    private status:string = '';
    public get Status():string{ return this.status  }
    public set Status(value:string){ this.status = value ; this.update()  }

    private type:string = '';
    public get Type():string{ return this.type  }
    public set Type(value:string){ this.type = value ; this.update()  }

    public getData(){
        this.loading(
            async()=>{
                if(this.val()){
                    try{
                        const response = await ApiRequest.transactionsSheet({search:this.search , from:this.from , to:this.to , status:this.status , type:this.type})
                        console.log(response)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.data = response.data.data.data
                                    this.total = response.data.data.total?response.data.data.total:'0'
                                    this.update()
                                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            }
        )
    }

    public val(){
        if(!this.from){  return false }
        if(!this.to){  return false }
        return true
    }

    public downloadExcel()  {
        const worksheet = XLSX.utils.json_to_sheet(
            this.data.map(item=>({
                'م':item.id,
                'العربي':item.arabic_name,
                'التخصص':item.level_specialization_name,
                'المسوق':item.marketer_name,
                'الحساب':item.account_name,
                'المدفوع':item.value,
                'سعر العملة':item.currencyPrice,
                'القيمة بالدولار':item.paid,        
                'تاريخ التحويل':item.date,
                'حالة السداد للمسوق':item.is_done=='done'?'تم التسليم':'لم يتم التسليم',
                'النوع':item.type,
                'مدفوعات اضافية':item.additional_amount,
                'قيمة المدفوعات الاضافية بالدولار':item.additional_value,
                'ملاحظات':item.notes
            }))
        )
        const workbook = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'transactions_from_'+this.from+'_to_'+this.to+'.xlsx');
      };

}